import { markConversationAsReadApi as generatedApi } from '../generated/conversations/markConversationAsRead';

import { getConversationsApi } from './getConversations';

const markConversationAsReadApi = generatedApi.enhanceEndpoints({
  endpoints: {
    markConversationAsRead: {
      onQueryStarted: async ({ conversationId }, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;

          dispatch(
            getConversationsApi.util.updateQueryData('getConversations', {}, (draft) => {
              const conversation = draft.data.find((c) => c.id === conversationId);

              if (conversation != null) {
                conversation.unreadCount = data.unreadCount;
              }
            }),
          );
        } catch {
          // Ignore errors
        }
      },
    },
  },
});

export const { useMarkConversationAsReadMutation } = markConversationAsReadApi;
